import React from 'react';

const SectionTitle = ({ children }) => (
    <h2 className="text-3xl md:text-4xl font-bold text-white mb-12 text-center">{children}</h2>
);

export default SectionTitle;